export const AdminReload = () => {

    console.log("AdminReload rendered");

    const reload = async () => {
        console.log("START");
        debugger;

        try {
            const response = await fetch(
                "http://localhost:8082/api/v1/admin/reload",
                {
                    headers: {
                        Authorization:
                            "Basic " + btoa("admin:secret123")
                    }
                }
            );

            console.log("DONE", response.status);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <button
            onClick={(e) => {
                console.log("INLINE");
                reload();
            }}
        >
            Reload
        </button>
    );
};